import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import Parser from 'html-react-parser';
import moment from 'moment';
import { RaisedButton } from 'material-ui';
import SvgIcon from 'react-icons-kit';
import { print } from 'react-icons-kit/fa/print';
var Config = require('../../../../config');

class DetailsApheresis extends Component{
	constructor(props){
		super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.getAnswersApheresis = this.getAnswersApheresis.bind(this);
        this.printReport = this.printReport.bind(this);

		this.state = {
            patient_name:"",
            patient_lastname1:"",
            patient_lastname2:"",
            patient_sex:"",
            sex:"",
            apheresis_fields_values:[],
            campos:[],
            preview_print:{}
		}
	}

	componentDidMount(){
        fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
        })
        
        fetch(Config.default.apiGateway.URL+'petitions/apheresis_values/'+this.props.match.params.id,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((m)=>{
                    swal('Error', m, 'error');
                })
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({
                    birthdate: response.birthday !== null ? moment(response.birthday).format('DD/MM/YYYY') : "",
                    patient_name:response.names,
                    patient_lastname1: response.lastname1,
                    patient_lastname2: response.lastname2,
                    petition_type: response.name,
                    clinic_history:response.clinic_history,
                    apheresis_fields_values: response.petition_apheresis_values,
                    sex: response.sex
                });

                this.getFormulario(response.petition_type_id, response.sex);
            }
        });
	}

	componentWillUnmount(){
	}

	getFormulario(id, sex){
		fetch(Config.default.apiGateway.URL+'apheresis_fields/by_petition_type?petition_type_id='+id+'&sex='+sex,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json' 
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({campos: response});

				setTimeout(()=>{
					if(this.state.apheresis_fields_values.length > 0){
						this.state.apheresis_fields_values.map((a)=>
							document.getElementById(a.apheresis_field_id).value = a.value
						);
					}
				}, 500)
			}
        })
    }

    getAnswersApheresis(){
		var obj = {}, res =[];

		this.state.campos.map((c)=>{
            c.fields.map((s) => {
                obj = {
                    apheresis_field_id: s.id,
                    value: document.getElementById(s.id) !== null ? document.getElementById(s.id).value : ""
                }

                var index = this.state.apheresis_fields_values.indexOf(obj => 
                    obj.apheresis_field_id === s.id
                );

                if(index !== -1){
                    obj.id = this.state.apheresis_fields_values[index].id;
                    obj.petition_id = this.state.apheresis_fields_values[index].petition_id;

                    if(obj.value !== ""){
                        res.push(obj);
                    }
                }else{
                    if(obj.value !== ""){
                        res.push(obj);
                    }
                }
            })
		})
		
		return res;
	}

	handleSubmit(e){
        e.preventDefault();
        var obj = [];
        var petition_apheresis_values = this.getAnswersApheresis();
        obj = petition_apheresis_values;
        
        fetch(Config.default.apiGateway.URL+'petitions/apheresis_values/'+this.props.match.params.id,{
            method:'POST',
            body:JSON.stringify(obj),
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((m)=>{
                    swal('Error', m, 'error');
                })
            }
        }).then(response => {
            if(response !== undefined){
                this.props.history.goBack();
            }
        });
    }
    
    printReport(e){
        e.preventDefault();
        this.props.waiting.handleShow('Imprimiento...');
        fetch(Config.default.apiGateway.URL+'petitions/print_apheresis/'+this.props.match.params.id,{
            method:'POST',
            responseType: 'blob',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.blob();
            }else{
                res.text().then((m)=>{
                    swal('Error', m, 'error');
                })
            }
        }).then(response => {
            if(response !== undefined){
                if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=>{
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"laboratory", "File": "'+aux[1]+'"}');
					}
				}
            }
        });
    }

	render(){
        const {t} = this.props;
        var session = sessionStorage.getItem('health_facilities_name');
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Buscar paciente
					</h5>
				</div>
		        	<div className="col-xs-12 form-group">
                        <div className="col-xs-12">
                            <form>
                                <fieldset>
                                    <legend>Paciente</legend>
                                    <div className="form-group">
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">Nombre(s)</span>
                                            <input className="form-control input-sm" value={this.state.patient_name}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">A. Paterno</span>
                                            <input className="form-control input-sm" value={this.state.patient_lastname1}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">A. Materno</span>
                                            <input className="form-control input-sm" value={this.state.patient_lastname2}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">F. Nacimiento</span>
                                            <input className="form-control input-sm" value={this.state.birthdate}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">Género</span>
                                            <input className="form-control input-sm" value={this.state.sex}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">No. Expediente</span>
                                            <input className="form-control input-sm" value={this.state.clinic_history}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            <span className="span-min">Tipo de Petición</span>
                                            <input className="form-control input-sm" value={this.state.petition_type}
                                                onChange={(e)=>e.preventDefault()} disabled/>
                                        </div>
                                    </div>
                                    
                                </fieldset>

                                {this.state.campos.map((cat, index) =>
                                    <fieldset key={index}>
                                        <legend>{cat.category}</legend>
                                        <div className="form-group col-xs-12">
                                            {cat.fields.map((c, i) =>
                                                <div className="col-xs-12 col-sm-2" key={i}>
                                                    <span className="span-min">{c.field_label}</span>
                                                    {Parser(c.html)}
                                                </div>
                                            )}
                                        </div>
                                    </fieldset>
                                )}
                            </form>
                        </div>
                    
		        	</div>
                    <div className="col-xs-12" style={{textAlign:'center'}}>
                            <button className="toolIcon" 
								onClick={this.printReport}	>
								<SvgIcon size={50} icon={print} />
                                <div>Imprimir</div>
							</button>
                    </div>
                                        
                    <div className="col-xs-12" style={{textAlign:'center'}}>
                        <RaisedButton className="action-btn" label="GUARDAR" primary={true}
                            onClick={this.handleSubmit} style={{margin:7}} />
                        <RaisedButton className="action-btn" label="REGRESAR" primary={true} onClick={()=>this.props.history.goBack()} 
                            style={{margin:7}}/>
                    </div>
                
	      	</div>
		)
	}
}

export default translate('translations')(DetailsApheresis)